// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__17jo1","col":"styles_col__35AvI","fulfillmentStatus":"styles_fulfillmentStatus__OmbbL","emailCol":"styles_emailCol__RL1tu"};